import { ReactElement } from 'react';
import DisplayAreaCenteredWrapper from '../../../layout/utilities/displayAreaWrapper';
import makeStyles from '@mui/styles/makeStyles';
import RaptorLogoWithText from '../../../../images/RaptorLogoWithText.png';
import { RaptorTheme, mainColors } from '../../../../styling/theme';

const useStyles = makeStyles<RaptorTheme>(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1.25rem',
    marginBottom: '6.25rem',
    backgroundColor: 'white',
    padding: '2.50rem 3.75rem 2.50rem 3.75rem',
    borderRadius: '1.25rem',
  },
  logo: {
    marginBottom: '0.62rem',
  },
  message: {
    fontSize: '2.50rem',
    fontWeight: 500,
    color: mainColors.mainBlue,
    textAlign: 'center',
  },
  messageSecond: {
    fontSize: '1.88rem',
    fontWeight: 500,
    color: mainColors.mainBlue,
    textAlign: 'center',
  },
}));

/** Accepts page-model payload or legacy DataObject (`{ data: [payload] }`). */
export function doesClientHavePremiumPackage(esgData: any): boolean {
  if (!esgData) return true;

  const payload = Array.isArray(esgData.data) ? esgData.data[0] : esgData;
  if (!payload) return true;
  if (!('esg_subscription_package' in payload)) return true;
  return payload.esg_subscription_package === 'esg_premium_package';
}

const NonPremiumSubscriptionDisplayMessage = (): ReactElement => {
  const classes = useStyles();

  return (
    <DisplayAreaCenteredWrapper>
      <div className={classes.container}>
        <div>
          <img
            src={RaptorLogoWithText}
            alt={'Raptor Logo'}
            className={classes.logo}
          />
        </div>
        <div className={classes.message}>This is an ESG premium feature.</div>
        <div className={classes.messageSecond}>
          To upgrade, please contact the RiskSystem team.
        </div>
      </div>
    </DisplayAreaCenteredWrapper>
  );
};

export default NonPremiumSubscriptionDisplayMessage;
